import {
  OrderValue as InterviewOrderValue,
  sortableColumns as interviewSortableColumns,
} from 'components/Interview/List';
import { List } from 'store/actions/mentor/interviewLists';
import ActionTypes from 'store/actionTypes/mentor/interviewLists';
import updateObject from 'store/updateObject';
import {
  isNumberAction,
  isOrderAction,
  TypedAction,
} from 'types/typeguards/reducerActions';

export type InterviewListsState = {
  main: {
    page: number;
    order: InterviewOrderValue;
  };
  mentee: {
    page: number;
    order: InterviewOrderValue;
  };
};

const initialState: InterviewListsState = {
  main: {
    page: 0,
    order: 'desc/date',
  },
  mentee: {
    page: 0,
    order: 'desc/date',
  },
};

const setPage = (
  list: List,
  state: InterviewListsState,
  action: TypedAction<number>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      page: action.value,
    }),
  });
};

const setOrder = (
  list: List,
  state: InterviewListsState,
  action: TypedAction<InterviewOrderValue>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      order: action.value,
      page: 0,
    }),
  });
};

const interviewListReducer = (
  state = initialState,
  action: { type: string },
) => {
  switch (action.type) {
    case ActionTypes.MAIN_INTERVIEWS_SET_PAGE:
      if (isNumberAction(action)) {
        return setPage('main', state, action);
      }
      console.log('Action type error: setPage');
      return state;
    case ActionTypes.MENTEE_INTERVIEWS_SET_PAGE:
      if (isNumberAction(action)) {
        return setPage('mentee', state, action);
      }
      console.log('Action type error: setPage');
      return state;

    case ActionTypes.MAIN_INTERVIEWS_SET_ORDER:
      if (isOrderAction(interviewSortableColumns, action)) {
        return setOrder('main', state, action);
      }
      console.log('Action type error: setOrder');
      return state;

    case ActionTypes.MENTEE_INTERVIEWS_SET_ORDER:
      if (isOrderAction(interviewSortableColumns, action)) {
        return setOrder('mentee', state, action);
      }
      console.log('Action type error: setOrder');
      return state;

    default:
      return state;
  }
};

export default interviewListReducer;
